// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.huddln",
    name: "Huddln",
    homepage: "https://www.huddln.io",
    image_id: "7ba1571c-10c4-4284-b438-04dac27cb700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/huddln-nft-social-network/id1503825604",
        android: "https://play.google.com/store/apps/details?id=com.huddln&hl=en_US&gl=US",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "huddln://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map